import { useDashboardSearchQuery } from "~graphql/dashboard-home.generated"

export default function useDashboardSearch({
    searchText,
    outfitterId,
}: {
    searchText: string
    outfitterId: string
}) {
    const {
        data,
        loading: isLoading,
        error,
    } = useDashboardSearchQuery({
        variables: { outfitterId, query: searchText },
        skip: !searchText || searchText.length < 2 || !outfitterId, // Skip search for very short queries or missing outfitterId
    })

    const groups = data?.dashboardSearch.groups ?? []
    const query = data?.dashboardSearch.query ?? ""

    return { groups, query, isLoading, error }
}
